import { FIRM_SUMMARY_SPREADSHEET_COLUMNS } from 'pages/Firms/common/constants';
import { generateTotalExpression, getObjectValue } from 'utilities';
import { HandleParentCells } from './types';

const { gross_irr: GROSS_IRR } = FIRM_SUMMARY_SPREADSHEET_COLUMNS;

const handleParentCells = (params: HandleParentCells): void => {
  const { cell, colNumber, rowNumber, companiesGrossIRR } = params;
  const { data } = getObjectValue(cell);
  const { isParent, fundsCount, companyId } = getObjectValue(data);

  if (isParent && fundsCount) {
    const childFundsCount = Array.from({ length: fundsCount }, (_, index) => index + 1); // +1 for 0-based index

    const childFundsExpression = generateTotalExpression({
      generateIndex: false,
      items: childFundsCount,
      skippedIndexes: rowNumber,
    });

    // For Gross IRR column, use the company-level Gross IRR (calculated across all funds)
    if (colNumber === GROSS_IRR.column) {
      const companyGrossIRR = companiesGrossIRR && companyId ? companiesGrossIRR[companyId] : null;
      Object.assign(cell, {
        expr: '',
        gridType: 'percentage',
        value: companyGrossIRR,
      });
    } else {
      Object.assign(cell, {
        expr: `=SUM(${childFundsExpression})`,
      });
    }
  }
};

export default handleParentCells;
